import React, { useEffect, useCallback, useState } from "react";
import {
  Box,
  Container,
  Grid,
  Card,
  Stack,
  Typography,
  Skeleton,
} from "@mui/material";
import {
  AddCircleOutline as AddIcon,
  Refresh as RefreshIcon,
} from "@mui/icons-material";
import { useHistory } from "react-router-dom";
import FiveSlotWorking from "./components/FiveSlotWorking";
import FiveSlotHeroBanner from "./components/FiveSlotHeroBanner";
import FiveSlotMachineCard from "./components/FiveSlotMachineCard";
import { CommonBreadcrumbs, CommonButton, toast } from "../../../Components/ui";
import { Path } from "../../../../static/Constants";
import { FIVE_SLOT_CONFIG } from "./components/fiveSlotConfig";
import { colors, borderRadiusPx } from "../../../../theme";
import NavBar from "../../../Components/NavBar";

import {
  getConnectedAccount,
  connectWallet as triggerConnectWallet,
  subscribeToWalletEvents,
} from "../../../../static/walletUtils";

import "./FiveSlotLottery.css";
import slotInstance from "../../../Service/slotInstance";
import web3 from "../../../Service/web3";

export const DUMMY_LOTTERIES = [
  {
    lotteryId: 201,
    name: "5-SlotBET",
    creator: "AutoBET Official",
    slotCategory: "fiat",
    currency: "BET",
    jackpots: {
      mini: {
        amount: "2840.50",
        seedValue: "2000.00",
        contributionPerSpin: "0.030",
      },
      major: {
        amount: "16450.00",
        seedValue: "10000.00",
        contributionPerSpin: "0.012",
      },
      mega: {
        amount: "128900.00",
        seedValue: "50000.00",
        contributionPerSpin: "0.005",
      },
    },
  },
];

const FiveSlotLottery = () => {
  const history = useHistory();

  const [account, setAccount] = useState("");
  const [lotteries, setLotteries] = useState([]);
  const [loading, setLoading] = useState(true);
  console.log("lotteries", lotteries);
    const fetchSlotGames = useCallback(async () => {
        setLoading(true);

        try {
            if (!slotInstance?.methods?.getOngoingGames) {
                console.warn("getOngoingGames method not found on slotInstance");
                setLotteries([]);
                return;
            }

            const ongoingGames = await slotInstance.methods
                .getOngoingGames()
                .call();

            console.log("Raw ongoing 5-slot games:", ongoingGames);

            const mappedLotteries = ongoingGames
                // Safely check reels (index 1) and active status (index 9) for 5-REEL GAMES
                .filter((game) => Number(game.reels || game[1]) === 5 && Boolean(game.active ?? game[9]))
                .map((game, index) => {

                    // BULLETPROOF STRUCT MAPPING (Matches your exact Solidity struct)
                    const gameId = game.gameId || game[0] || index + 1;
                    const reels = game.reels || game[1];
                    const isCrypto = game.isCrypto ?? game[2];
                    const minBet = game.minBet || game[3] || "0";
                    const maxBet = game.maxBet || game[4] || "0";
                    const progBps = Number(game.progressiveContributionBps || game[5]) || 0;
                    const miniBps = Number(game.miniBps || game[6]) || 0;
                    const majorBps = Number(game.majorBps || game[7]) || 0;
                    const megaBps = Number(game.megaBps || game[8]) || 0;
                    const active = game.active ?? game[9];
                    const startTime = game.startTime || game[10];
                    const endTime = game.endTime || game[11];
                    const owner = game.owner || game[12];
                    const partnerWallet = game.partnerWallet || game[13];
                    const partnerShareBps = game.partnerShareBps || game[14];
                    const adminBps = game.adminBps || game[15];

                    // SHIFTED POOLS
                    const miniPool = game.miniPool || game[16] || "0";
                    const majorPool = game.majorPool || game[17] || "0";
                    const megaPool = game.megaPool || game[18] || "0";

                    // Format Wei to Ether safely
                    const ticketPriceFormatted = web3?.utils?.fromWei
                        ? web3.utils.fromWei(String(minBet), "ether")
                        : String(minBet);

                    const maxBetFormatted = web3?.utils?.fromWei
                        ? web3.utils.fromWei(String(maxBet), "ether")
                        : String(maxBet);

                    const miniPrizeFormatted = web3?.utils?.fromWei
                        ? web3.utils.fromWei(String(miniPool), "ether")
                        : String(miniPool);

                    const majorPrizeFormatted = web3?.utils?.fromWei
                        ? web3.utils.fromWei(String(majorPool), "ether")
                        : String(majorPool);

                    const megaPrizeFormatted = web3?.utils?.fromWei
                        ? web3.utils.fromWei(String(megaPool), "ether")
                        : String(megaPool);

                    // Numbers for UI calculations
                    const numericMini = Number(miniPrizeFormatted) || 0;
                    const numericMajor = Number(majorPrizeFormatted) || 0;
                    const numericMega = Number(megaPrizeFormatted) || 0;
                    const numericTicketPrice = Number(ticketPriceFormatted) || 0;
                    const numericMaxBet = Number(maxBetFormatted) || 0;

                    // Calculate accurate per-spin contributions based on BPS
                    const totalProgContribution = (numericTicketPrice * progBps) / 10000;

                    return {
                        lotteryId: Number(gameId),
                        gameId: Number(gameId),
                        name: `5-SlotBET #${gameId}`,
                        creator: owner
                            ? `${owner.slice(0, 6)}...${owner.slice(-4)}`
                            : "AutoBET Official",
                        owner,
                        reels: Number(reels),
                        active: active,
                        startTime: startTime,
                        endTime: endTime,
                        ticketPrice: ticketPriceFormatted,
                        slotCategory: isCrypto ? "crypto" : "fiat",
                        currency: "BET",
                        jackpots: {
                            mini: {
                                amount: numericMini.toFixed(2),
                                seedValue: ((numericMaxBet * miniBps) / 10000).toFixed(2),
                                contributionPerSpin: ((totalProgContribution * miniBps) / 10000).toFixed(4),
                            },
                            major: {
                                amount: numericMajor.toFixed(2),
                                seedValue: ((numericMaxBet * majorBps) / 10000).toFixed(2),
                                contributionPerSpin: ((totalProgContribution * majorBps) / 10000).toFixed(4),
                            },
                            mega: {
                                amount: numericMega.toFixed(2),
                                seedValue: ((numericMaxBet * megaBps) / 10000).toFixed(2),
                                contributionPerSpin: ((totalProgContribution * megaBps) / 10000).toFixed(4),
                            },
                        },
                    };
                });

            console.log("Mapped 5-slot games:", mappedLotteries);
            setLotteries(mappedLotteries);

        } catch (error) {
            console.error("Fetch 5-Slot Games Error:", error);
            toast.error("Unable to load 5-SlotBET games.");
            setLotteries([]);
        } finally {
            setLoading(false);
        }
    }, []);

  const combinedPrize = lotteries
    .reduce((acc, lottery) => {
      return (
        acc +
        parseFloat(lottery.jackpots.mini.amount) +
        parseFloat(lottery.jackpots.major.amount) +
        parseFloat(lottery.jackpots.mega.amount)
      );
    }, 0)
    .toFixed(2);

  const checkAccount = useCallback(async () => {
    const acc = await getConnectedAccount();
    setAccount(acc);
  }, []);

  const connectWallet = async () => {
    const res = await triggerConnectWallet();

    if (res.account) {
      setAccount(res.account);
    } else if (res.error === "NO_WALLET") {
      toast.error(res.message);
    } else if (res.isPending) {
      toast.info(res.message);
    } else if (!res.isCancelled && res.message) {
      toast.error(res.message);
    }
  };

  const handleOpenLottery = (lotteryId) => {
    history.push(`/five-slotlottery/${lotteryId}`);
  };

  useEffect(() => {
    checkAccount();
    fetchSlotGames();

    const unsubscribe = subscribeToWalletEvents({
      onAccountsChanged: (acc) => {
        setAccount(acc);
      },
      onDisconnect: () => setAccount(""),
    });

    return unsubscribe;
  }, [checkAccount, fetchSlotGames]);

  return (
    <Box
      sx={{
        position: "relative",
        overflowX: "hidden",
        minHeight: "100vh",
        bgcolor: colors.dashboard.canvas,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <NavBar />

      <Container
        maxWidth="xl"
        className="slot-page-container five-slot-page-container"
        sx={{
          pt: { xs: "96px", sm: "108px", md: "116px" },
          pb: 8,
          flexGrow: 1,
        }}
      >
        <Box sx={{ mb: 4 }}>
          <CommonBreadcrumbs
            items={[
              { label: "Home", path: Path.root },
              { label: "All Lotteries", path: Path.allLotteries },
              { label: `${FIVE_SLOT_CONFIG.name}` },
            ]}
          />
        </Box>

        <FiveSlotHeroBanner
          totalActive={lotteries.length}
          combinedPrize={combinedPrize}
          currency="BET"
        />

        {loading ? (
          <Grid container spacing={3} alignItems="flex-start">
            {[1, 2, 3].map((n) => (
              <Grid item xs={12} sm={6} lg={4} key={n}>
                <Card
                  sx={{
                    p: { xs: 2, sm: 2.5 },
                    borderRadius: borderRadiusPx.xl,
                    border: "1px solid #e2e8f0",
                    bgcolor: "#ffffff",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.04)",
                  }}
                >
                  <Skeleton
                    variant="rectangular"
                    height={4}
                    sx={{
                      mb: 2,
                      mx: { xs: -2, sm: -2.5 },
                      mt: { xs: -2, sm: -2.5 },
                    }}
                  />
                  <Box
                    sx={{
                      display: "flex",
                      gap: 1.5,
                      mb: 2,
                      alignItems: "center",
                    }}
                  >
                    <Skeleton
                      variant="rounded"
                      width={38}
                      height={38}
                      sx={{ borderRadius: "8px" }}
                    />
                    <Box sx={{ flex: 1 }}>
                      <Skeleton variant="text" width="60%" height={22} />
                      <Skeleton variant="text" width="40%" height={16} />
                    </Box>
                  </Box>
                  <Skeleton
                    variant="rounded"
                    height={52}
                    sx={{ mb: 2, borderRadius: "8px" }}
                  />
                  <Skeleton
                    variant="rounded"
                    height={108}
                    sx={{ mb: 2, borderRadius: "14px" }}
                  />
                  <Skeleton
                    variant="rounded"
                    height={36}
                    sx={{ mb: 2, borderRadius: "8px" }}
                  />
                  <Skeleton
                    variant="rounded"
                    height={42}
                    sx={{ borderRadius: "10px" }}
                  />
                </Card>
              </Grid>
            ))}
          </Grid>
        ) : lotteries.length === 0 ? (
          <Card
            sx={{
              p: { xs: 4, sm: 6 },
              textAlign: "center",
              borderRadius: borderRadiusPx.xl,
              backgroundColor: "#ffffff",
              border: "1px solid #e2e8f0",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)",
              my: 3,
            }}
          >
            <Box
              sx={{
                width: 68,
                height: 68,
                mx: "auto",
                mb: 2,
                borderRadius: "50%",
                bgcolor: "#eff6ff",
                color: "#2563eb",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "2rem",
                border: "1.5px solid #dbeafe",
                boxShadow: "0 2px 10px rgba(37, 99, 235, 0.15)",
              }}
            >
              🎰
            </Box>
            <Typography
              variant="h5"
              sx={{ fontWeight: 800, color: colors.slate[900], mb: 1 }}
            >
              No Active 5-SlotBET Games Found
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: colors.slate[600],
                mb: 3,
                maxWidth: 460,
                mx: "auto",
                lineHeight: 1.6,
              }}
            >
              There are currently no active 5-slot machines deployed on-chain.
              Create one to be the first house owner or refresh to check for new
              games!
            </Typography>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="center"
              flexWrap="wrap"
            >
              <CommonButton
                variant="refresh"
                startIcon={<RefreshIcon />}
                onClick={fetchSlotGames}
              >
                Refresh
              </CommonButton>
            </Stack>
          </Card>
        ) : (
          <Grid container spacing={3} alignItems="flex-start">
            {lotteries.map((lottery) => (
              <Grid item xs={12} sm={6} lg={4} key={lottery.lotteryId}>
                <FiveSlotMachineCard
                  lotteryData={lottery}
                  account={account}
                  onConnectWallet={connectWallet}
                  onPlay={handleOpenLottery}
                />
              </Grid>
            ))}
          </Grid>
        )}

        <FiveSlotWorking />
      </Container>
    </Box>
  );
};

export default FiveSlotLottery;
